import { isEmpty } from 'srcReact/helpers/validator'
import { messengerConstants as mc } from 'srcReact/MessengerPage'

const initialState = {
  searchedMembers: [],
  loading: false,
  searchedMemberError: null,
  searchedMemberStats: null,
  error: null,
  isMessageDeleted: false,
  isMessageEdited: false,
  isMessagePosted: false,
  loadingEditMessage: false,
  loadingInSidebar: false,
  loadingInShareModal: false,
  loadingSendMessage: false,
  manageMemberLoading: false,
  reactionProcessing: false,
  reactionToProcess: null,
  openedFromLightProfile: false,
  isSidebarVisibile: true,
  isMainContentVisible: false,
  originMessage: null,
  organizationId: 0,
  sidebarScreenType: 'search',
  //hasFiles: false,
  pendingMessages: [],
  openedConversation: {
    loading: false,
    loaded: false,
    is_allowed: 0,
    conversation: {
      id: 0,
      is_new_conversation: 0,
      is_group_conversation: 0,
      user_conversation_name: '',
      user_is_conversation_admin: 0,
      userAddedAt: '',
      userReceivedAt: '',
      userOpenedAt: '',
      isMutedByUser: 0,
      isLeftByUser: 0,
      hasBeenRemoved: 0,
      userUnreadMessageCount: 0,
      workplaceID: 0,
      organizationID: 0,
      creatorUserId: 0,
      activeUsersCount: 0,
      inactiveUsersCount: 0,
      createdAt: '',
      updatedAt: '',
      deletedAt: ''
    },
    active_users: [],
    inactive_users: [],
    content: {
      stat: {
        total: 0,
        nextOffset: 0,
        remaining: 0
      },
      message_draft: {
        message: ''
      },
      messages: []
    }
  },
  conversation: {
    // conversationIdForNewMessage: 0, // this id is the conversation id in which the new message is being posted.
    // //if we change the conversation while file upload is in process, it attached wrong conv id to message
    // //https://app.asana.com/0/1140988629330369/1205212072861079
    // conversationIdForNewContent: 0, // this id is the conversation id in which the new message is being posted.
    // //if we change the conversation while content or file upload is in process, it attached wrong conv id to message
    // //https://app.asana.com/0/435521841776008/1205291582166240
    loading: true,
    loaded: false,
    stats: {
      total: 0,
      nextOffset: 0,
      remaining: 0
    },
    list: []
  },
  search: {
    loading: false,
    loaded: false,
    stats: {
      total: 0,
      nextOffset: 0,
      remaining: 0
    },
    list: []
  },
  filterItem: 'all',
  scrollToMessage: {
    conversation_id: 0,
    message_id: 0,
    content_offset: 0
  },
  messageTags: {
    loading: false,
    tags: [],
    error: ''
  }
}

export function messenger(state = initialState, action) {
  const { response } = action

  switch (action.type) {
    case mc.SET_ORGANIZATION_ID:
      return {
        ...state,
        organizationId: action.id
      }
    case mc.GET_CONVERSATIONS_LIST_REQUEST:
      return {
        ...state,
        conversation: {
          ...state.conversation,
          loading: true,
          loaded: false
        }
      }
    case mc.GET_CONVERSATIONS_LIST_SUCCESS:
      return {
        ...state,
        conversation: {
          ...state.conversation,
          // conversationIdForNewContent: action.data.list[0]?.conversation.id, // Set first conversation in desktop's conversation list as active
          list: action.data.list,
          stats: {
            ...state.conversation.stats,
            ...action.data.stats
          },
          loading: false,
          loaded: true
        },
        openedConversation: {
          ...state.openedConversation,
          ...(state.openedConversation.is_allowed === 0 && action.data.list[0]),
          loading: false,
          loaded: true
        }
      }
    case mc.GET_CONVERSATIONS_LIST_FAILURE:
      return {
        ...state,
        conversation: {
          ...state.conversation,
          loading: false,
          loaded: true
        }
      }
    case mc.GET_CONVERSATIONS_LIST_PAGINATION_REQUEST:
      return {
        ...state,
        conversation: {
          ...state.conversation,
          loading: true
        }
      }
    case mc.GET_CONVERSATIONS_LIST_PAGINATION_SUCCESS:
      let nextConversationsList = [...state.conversation.list]
      const nextConversationsListIds = new Set(action.data.list.map((c) => c.conversation.id))
      nextConversationsList = [
        ...state.conversation.list.filter((c) => !nextConversationsListIds.has(c.conversation.id)),
        ...action.data.list
      ]
      return {
        ...state,
        conversation: {
          ...state.conversation,
          list: nextConversationsList,
          stats: {
            ...state.conversation.stats,
            ...action.data.stats
          },
          loading: false
        }
      }
    case mc.GET_CONVERSATIONS_LIST_PAGINATION_FAILURE:
      return {
        ...state,
        conversation: {
          ...state.conversation,
          loading: false
        }
      }
    case mc.GET_CONVERSATIONS_SEARCH_REQUEST:
      return {
        ...state,
        search: {
          ...state.search,
          list: [],
          loading: true,
          loaded: false
        }
      }
    case mc.GET_CONVERSATIONS_SEARCH_SUCCESS:
      return {
        ...state,
        search: {
          ...state.search,
          list: updateSearchConversationsList(
            action.data.conversations,
            {},
            action.data.users_names,
            action.data.messages
          ),
          stats: {
            ...state.search.stats,
            ...action.data.stats
          },
          loading: false,
          loaded: true
        }
      }
    case mc.REALTIME_CONVERSATIONS_UPDATE_SUCCESS:
      if (action.data.list && action.data.list.length >= 1) {
        return {
          ...state,
          conversation: {
            ...state.conversation,
            list: updateConversations(state.conversation.list, action.data.list)
          }
        }
      }
      return {
        ...state
      }
    case mc.REALTIME_OPEN_CONVERSATION_UPDATE_SUCCESS:
      if (state.openedConversation.loaded && !state.openedConversation.loading && !state.loadingSendMessage) {
        const newTags = action.data.content?.stat?.background_posting
        const updatedPendingMessages = state.pendingMessages.filter((message) => newTags.includes(message.tag))
        return {
          ...state,
          conversation: {
            ...state.conversation,
            list: updateConversationsList(state.conversation.list, { ...action.data })
          },
          openedConversation: {
            ...state.openedConversation,
            ...updateOpenedConversation(state.openedConversation, [{ ...action.data }])
          },
          pendingMessages: updatedPendingMessages,
          messageTags: { ...state.messageTags, tags: action.data.content?.stat?.background_posting }
        }
      }
      return {
        ...state
      }
    case mc.GET_CONVERSATION_OPEN_REQUEST:
      return {
        ...state,
        originMessage: null,
        messageTags: initialState.messageTags,
        openedConversation: {
          ...state.openedConversation,
          ...action.data.conversation,
          content: {
            ...state.openedConversation.content,
            ...action.data.conversation?.content,
            message_draft: {
              message: ''
            },
            messages: []
          },
          loading: true,
          loaded: false
        },
        isSidebarVisibile: false,
        isMainContentVisible: true
      }

    case mc.GET_CONVERSATION_OPEN_SUCCESS:
      return {
        ...state,
        conversation: {
          ...state.conversation,
          list: updateConversationsList(state.conversation.list, { ...action.data })
        },
        messageTags: {
          ...initialState.messageTags,
          tags: action.data.content?.stat?.background_posting
        },
        openedConversation: {
          ...state.openedConversation,
          ...action.data,
          is_allowed: 1,
          loading: false,
          loaded: true
        },
        isSidebarVisibile: false,
        isMainContentVisible: true
      }
    case mc.GET_CONVERSATION_OPEN_FAILURE:
      return {
        ...state
      }
    case mc.GET_CONVERSATION_OPEN_PAGINATION_REQUEST:
      return {
        ...state,
        openedConversation: {
          ...state.openedConversation,
          loading: true,
          loaded: false
        }
      }
    case mc.GET_CONVERSATION_OPEN_PAGINATION_SUCCESS:
      const messagesIds = new Set(action.data.content.messages.map((m) => m.id))
      return {
        ...state,
        openedConversation: {
          ...state.openedConversation,
          ...action.data,
          content: {
            ...state.openedConversation.content,
            ...action.data.content,
            messages: [
              ...state.openedConversation.content.messages.filter((m) => !messagesIds.has(m.id)),
              ...action.data.content.messages
            ]
          },
          loading: false,
          loaded: true
        }
      }
    case mc.GET_CONVERSATION_OPEN_PAGINATION_FAILURE:
      return {
        ...state,
        openedConversation: {
          ...state.openedConversation,
          loading: true,
          loaded: false
        }
      }

    case mc.OPEN_CONVERSATION_FROM_NOTIFICATION_LINK_SUCCESS:
    case mc.CREATE_CONVERSATION_FROM_MAIL_LINK_SUCCESS:
      return {
        ...state,
        openedConversation: {
          ...state.openedConversation,
          ...action.data
        },
        isSidebarVisibile: false,
        isMainContentVisible: true
      }

    case mc.CLEAR_ERROR:
      return {
        ...state,
        error: null
      }
    case mc.SET_FROM_LIGHT_PROFILE:
      return {
        ...state,
        openedFromLightProfile: action.flag
      }

    case mc.SHOW_SIDEBAR:
      return {
        ...state,
        isSidebarVisibile: action.show
      }
    case mc.SHOW_MAIN_CONTENT:
      return {
        ...state,
        isMainContentVisible: action.show
      }
    case mc.SET_ORIGIN_MESSAGE:
      return {
        ...state,
        originMessage: action.message
      }
    case mc.SET_SIDEBAR_SCREEN:
      return {
        ...state,
        sidebarScreenType: action.screenType,
        searchedMemberError: null
      }

    case mc.SEARCH_MEMBER_REQUEST: {
      const { isPagination } = action
      return {
        ...state,
        loading: true,
        loadingInSidebar: true,
        searchedMemberError: null,
        searchedMembers: isPagination ? [...state.searchedMembers] : [],
        searchedMemberStats: isPagination ? { ...state.searchedMemberStats } : {}
      }
    }
    case mc.SEARCH_MEMBER_SUCCESS: {
      const { stats, list, search } = action.updatedResponse
      let updatedList = [...state.searchedMembers]

      if (action.updatedResponse.isPagination && list) {
        updatedList = [...state.searchedMembers, ...list]
      } else if (search?.length >= 2 || search?.length === 0 || state.searchedMembers.length === 0) {
        updatedList = list ? [...list] : []
      }
      return {
        ...state,
        searchedMembers: updatedList,
        searchedMemberStats: stats && { ...stats },
        loading: false,
        loadingInSidebar: false,
        searchedMemberError: null
      }
    }
    case mc.SEARCH_MEMBER_FAILURE:
      return {
        ...state,
        loading: false,
        loadingInSidebar: false,
        searchedMembers: [],
        searchedMemberError: action.error
      }

    case mc.CREATE_CONV_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case mc.CREATE_CONV_SUCCESS: {
      return {
        ...state,
        conversation: {
          ...state.conversation,
          // conversationIdForNewMessage: action.response.conversation.id,
          // conversationIdForNewContent: action.response.conversation.id,
          list: updateConversationsList(state.conversation.list, { ...action.response }, 'add')
        },
        openedConversation: {
          ...state.openedConversation,
          ...action.response,
          is_allowed: 1
        },
        loading: false,
        error: null
      }
    }
    case mc.CREATE_CONV_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }

    case mc.RENAME_CONV_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case mc.RENAME_CONV_SUCCESS: {
      return {
        ...state,
        loading: false,
        conversation: {
          ...state.conversation,
          list: updateConversationsList(state.conversation.list, { ...action.response })
        },
        openedConversation: {
          ...state.openedConversation,
          ...action.response
        },
        error: null
      }
    }
    case mc.RENAME_CONV_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }

    case mc.ADD_MEMBERS_TO_CONV_REQUEST:
    case mc.REMOVE_MEMBERS_FROM_CONV_REQUEST:
    case mc.SET_ADMIN_REQUEST:
      return {
        ...state,
        manageMemberLoading: true,
        error: null
      }
    case mc.ADD_MEMBERS_TO_CONV_SUCCESS:
    case mc.REMOVE_MEMBERS_FROM_CONV_SUCCESS:
    case mc.SET_ADMIN_SUCCESS: {
      return {
        ...state,
        manageMemberLoading: false,
        conversation: {
          ...state.conversation,
          list: updateConversationsList(state.conversation.list, { ...action.response })
        },
        openedConversation: {
          ...state.openedConversation,
          ...action.response
        },
        error: null
      }
    }
    case mc.ADD_MEMBERS_TO_CONV_FAILURE:
    case mc.REMOVE_MEMBERS_FROM_CONV_FAILURE:
    case mc.SET_ADMIN_FAILURE:
      return {
        ...state,
        manageMemberLoading: false,
        error: action.error
      }

    case mc.LEAVE_CONV_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case mc.LEAVE_CONV_SUCCESS: {
      let conversationsList = updateConversationsList(state.conversation.list, { ...action.response }, 'delete')
      return {
        ...state,
        loading: false,
        conversation: {
          ...state.conversation,
          list: conversationsList
        },
        openedConversation: {
          ...state.openedConversation,
          ...conversationsList[0]
        },
        error: null
      }
    }
    case mc.LEAVE_CONV_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }

    case mc.RESUME_CONV_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case mc.RESUME_CONV_SUCCESS: {
      return {
        ...state,
        loading: false,

        error: null
      }
    }
    case mc.RESUME_CONV_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }

    case mc.MUTE_CONV_REQUEST:
    case mc.UNMUTE_CONV_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case mc.MUTE_CONV_SUCCESS:
    case mc.UNMUTE_CONV_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        conversation: {
          ...state.conversation,
          list: updateConversationsList(state.conversation.list, { ...action.response })
        },
        openedConversation: {
          ...state.openedConversation,
          ...action.response
        }
      }
    }
    case mc.MUTE_CONV_FAILURE:
    case mc.UNMUTE_CONV_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }

    case mc.HIDE_CONV_REQUEST:
    case mc.DELETE_CONV_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case mc.HIDE_CONV_SUCCESS:
    case mc.DELETE_CONV_SUCCESS: {
      let conversationsList = updateConversationsList(state.conversation.list, { ...action.response }, 'delete')
      return {
        ...state,
        loading: false,
        conversation: {
          ...state.conversation,
          list: conversationsList
        },
        openedConversation: {
          ...state.openedConversation,
          ...conversationsList[0]
        },
        error: null
      }
    }
    case mc.DELETE_CONV_FAILURE:
    case mc.HIDE_CONV_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }

    case mc.POST_MESSAGE_REQUEST: {
      const { conversationId, tempMessageId } = action
      const updatedPendingMessages = state.pendingMessages.map((x) => {
        if (x.messageId == tempMessageId && x.parentObjectId == conversationId) {
          x.requested = true
        }
        return x
      })

      return {
        ...state,
        loadingSendMessage: true,
        // isMessagePosted: postedMessage.fileIds === null ? false : true,
        error: null,
        //  hasFiles: postedMessage.fileIds !== null,
        openedConversation: {
          ...state.openedConversation,
          content: {
            ...state.openedConversation.content
            // messages: [{ ...postedMessage }, ...state.openedConversation.content.messages]
          }
        },
        pendingMessages: updatedPendingMessages
      }
    }
    case mc.POST_MESSAGE_SUCCESS: {
      const { tempMessageId } = action
      const updatedPendingMessages = state.pendingMessages.filter((x) => x.messageId != tempMessageId)

      return {
        ...state,
        loadingSendMessage: false,
        originMessage: null,
        isMessagePosted: true,
        error: null,
        //  hasFiles: false,
        conversation: {
          ...state.conversation,
          list: updateConversationsList(state.conversation.list, { ...action.response }, 'add')
        },
        openedConversation: {
          ...state.openedConversation,
          ...updateOpenedConversation(state.openedConversation, [{ ...action.response }])
        },
        pendingMessages: updatedPendingMessages
      }
    }
    case mc.POST_MESSAGE_FAILURE:
      return {
        ...state,
        // hasFiles: false,
        loadingSendMessage: false,
        error: action.error
      }

    case mc.UPDATE_MESSAGE_REQUEST:
      return {
        ...state,
        loadingEditMessage: true,
        isMessageEdited: false,
        error: null
      }
    case mc.UPDATE_MESSAGE_SUCCESS: {
      return {
        ...state,
        loadingEditMessage: false,
        isMessageEdited: true,
        error: null,
        conversation: {
          ...state.conversation,
          list: updateConversationsList(state.conversation.list, { ...action.response })
        },
        openedConversation: {
          ...state.openedConversation,
          ...action.response
        }
      }
    }
    case mc.UPDATE_MESSAGE_FAILURE:
      return {
        ...state,
        loadingEditMessage: false,
        error: action.error,
        isMessageEdited: false
      }

    case mc.DELETE_MESSAGE_REQUEST:
      return {
        ...state,
        loading: true,
        isMessageDeleted: false,
        error: null
      }
    case mc.DELETE_MESSAGE_SUCCESS: {
      return {
        ...state,
        loading: false,
        isMessageDeleted: true,
        error: null,
        conversation: {
          ...state.conversation,
          list: updateConversationsList(state.conversation.list, { ...action.response })
        },
        openedConversation: {
          ...state.openedConversation,
          ...action.response
        }
      }
    }
    case mc.DELETE_MESSAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        isMessageDeleted: false
      }

    case mc.REFRESH_MESSAGES_REQUEST:
      return {
        ...state
      }
    case mc.GET_CONV_UPDATE_FAILURE:
      return {
        ...state
      }

    case mc.ADD_REACTION_REQUEST:
    case mc.DELETE_REACTION_REQUEST: {
      return {
        ...state,
        reactionProcessing: true,
        reactionToProcess: { code: response.reactionCode, messageId: response.messageId }
      }
    }
    case mc.ADD_REACTION_SUCCESS:
    case mc.DELETE_REACTION_SUCCESS: {
      return {
        ...state,
        reactionProcessing: false,
        error: null,
        reactionToProcess: null,
        conversation: {
          ...state.conversation,
          list: updateConversationsList(state.conversation.list, { ...action.response })
        },
        openedConversation: {
          ...state.openedConversation,
          ...action.response
        }
      }
    }
    case mc.ADD_REACTION_FAILURE:
    case mc.DELETE_REACTION_FAILURE:
      return {
        ...state,
        reactionProcessing: false,
        error: action.error,
        reactionToProcess: null
      }

    case mc.ADD_DRAFT_MESSAGE_REQUEST:
    case mc.ADD_DRAFT_MESSAGE_SUCCESS:
      return {
        ...state,
        openedConversation: {
          ...state.openedConversation,
          content: {
            ...state.openedConversation.content,
            message_draft: {
              message: action.message
            }
          }
        }
      }
    case mc.ADD_DRAFT_MESSAGE_FAILURE:
      return {
        ...state
      }

    case mc.SET_FILTER_ITEM:
      return {
        ...state,
        filterItem: action.filterItem
      }

    case mc.ADD_TO_PENDING_MESSAGES: {
      return {
        ...state,
        pendingMessages: [{ ...action.messageObject }, ...state.pendingMessages]
      }
    }

    case mc.REMOVE_FROM_PENDING_MESSAGES: {
      const updatedMessages = state.pendingMessages.filter((x) => x.messageId != action.messageId)
      return {
        ...state,
        pendingMessages: updatedMessages
      }
    }

    case mc.LOCATE_MESSAGE_IN_CONV_SUCCESS: {
      return {
        ...state,
        scrollToMessage: {
          ...state.scrollToMessage,
          conversation_id: action.response.conversation_id,
          message_id: action.response.message_id,
          content_offset: action.response.content_offset
        }
      }
    }
    case mc.RESET_SCROLL_TO_MESSAGE: {
      return {
        ...state,
        scrollToMessage: {
          ...state.scrollToMessage,
          conversation_id: 0,
          message_id: 0,
          content_offset: 0
        }
      }
    }
    case mc.CREATE_BG_TAG_REQUEST: {
      return {
        ...state,
        messageTags: {
          ...state.messageTags,
          loading: true
        }
      }
    }
    case mc.CREATE_BG_TAG_SUCCESS: {
      const { tempMessageId } = action
      const { tag } = action.response
      const updatedPendingMessages = state.pendingMessages.map((message) => {
        if (message.messageId === tempMessageId) {
          message.tag = tag
          message.processed = false
        }
        return message
      })
      return {
        ...state,
        pendingMessages: updatedPendingMessages,
        messageTags: {
          ...state.messageTags,
          loading: false,
          tags: [...state.messageTags.tags, tag]
        }
      }
    }
    case mc.CREATE_BG_TAG_FAILURE: {
      return {
        ...state,
        messageTags: {
          ...state.messageTags,
          loading: false,
          error: action.error
        }
      }
    }

    case mc.UPDATE_PROCESSED_TAG: {
      const updatedPendingMessages = state.pendingMessages.map((message) => {
        if (message.tag === action.tag) {
          message.processed = true
        }
        return message
      })
      return {
        ...state,
        pendingMessages: updatedPendingMessages
      }
    }
    default:
      return state
  }
}

// To update realtime conversations list
function updateConversations(conversationArray1, conversationArray2) {
  const key1 = 'id'
  const key2 = 'conversationId'

  const conversationsData = conversationArray1.map((el) => {
    const conversation = conversationArray2.find((c) => c[key2] === el.conversation[key1])
    if (conversation) {
      const messagesIds = new Set(conversation.content.messages.map((m) => m.id))
      return {
        ...el,
        conversation: {
          ...el.conversation,
          userUnreadMessageCount: conversation.total_new_messages_count,
          updatedAt: conversation.last_message_updated_at
        },
        active_users: [...el.active_users],
        inactive_users: [...el.inactive_users],
        content: {
          ...el.content,
          messages: [...conversation.content.messages, ...el.content.messages.filter((m) => !messagesIds.has(m.id))]
        }
      }
    }
    return el
  })

  // Sort conversationsData by updatedAt date
  conversationsData.sort((a, b) => new Date(b.conversation.updatedAt) - new Date(a.conversation.updatedAt))

  return conversationsData
}

// To update realtime opened conversation
function updateOpenedConversation(conversationObject, conversationArray) {
  let key = 'id'
  let conversation = conversationArray.find((c) => c.conversation[key] === conversationObject.conversation[key])
  if (conversation) {
    const messagesIds = new Set(conversation.content.messages.map((m) => m.id))
    return {
      ...conversation,
      conversation: {
        ...conversation.conversation,
        userUnreadMessageCount: conversationObject.conversation.userUnreadMessageCount,
        updatedAt: conversationObject.conversation.updatedAt
      },
      active_users: [...conversationObject.active_users],
      inactive_users: [...conversationObject.inactive_users],
      content: {
        ...conversationObject.content,
        messages: [
          ...conversation.content.messages,
          ...conversationObject.content.messages.filter((m) => !messagesIds.has(m.id))
        ]
      }
    }
  }
  return conversationObject
}

// To update conversation state
function updateConversationsList(conversationArray, conversationObject, action = 'update') {
  switch (action) {
    case 'delete':
      return conversationArray.filter((c) => c.conversation.id !== conversationObject.conversation.id)
    case 'add':
      return [
        conversationObject,
        ...conversationArray.filter((c) => c.conversation.id !== conversationObject.conversation.id)
      ]
    case 'update':
      return conversationArray.map((c) => {
        const messagesIds = new Set(conversationObject.content.messages.map((m) => m.id))
        if (c.conversation.id === conversationObject.conversation.id) {
          return {
            ...c,
            conversation: { ...conversationObject.conversation },
            active_users: [...conversationObject.active_users],
            inactive_users: [...conversationObject.inactive_users],
            content: {
              ...conversationObject.content,
              stat: conversationObject.content.stat,
              messages: [
                ...c.content.messages,
                ...conversationObject.content.messages.filter((m) => !messagesIds.has(m.id))
              ]
            }
          }
        }
        return c
      })
    default:
      return conversationArray
  }
}

// To update search state
function updateSearchConversationsList(conversationArray, conversationObject, userNamesArray = [], messagesArray = []) {
  const key = 'id'
  let updatedSearchConversationsList = conversationArray

  if (!isEmpty(conversationObject)) {
    updatedSearchConversationsList = conversationArray.map((el) => {
      if (el.conversation[key] === conversationObject.conversation[key]) {
        el = Object.assign({}, el, { ...conversationObject })
      }
      return el
    })
  }

  const userNamesConversationsIds = new Set(userNamesArray.flatMap((m) => m.conversations_ids))
  const messagesConversationsIds = new Set(messagesArray.map((m) => m.id_msg_conversation))

  const users = updatedSearchConversationsList.filter(
    (c) => c.conversation.is_group_conversation === 0 && userNamesConversationsIds.has(c.conversation[key])
  )

  const groups = updatedSearchConversationsList.filter(
    (c) => c.conversation.is_group_conversation === 1 && !messagesConversationsIds.has(c.conversation[key])
  )

  const updatedMessages = messagesArray.map((m) => {
    const conversation = updatedSearchConversationsList.find((c) => c.conversation[key] === m.id_msg_conversation)
    if (conversation) {
      return {
        conversation: {
          ...conversation.conversation
        },
        active_users: [...conversation.active_users],
        inactive_users: [...conversation.inactive_users],
        content: {
          stat: conversation.content.stat,
          messages: [{ ...m }]
        }
      }
    }
    return conversation
  })

  return [...users, ...groups, ...updatedMessages]
}
